<template>

    <div>
        <TowerSettings
            v-if="entity.id"
            :entity-type="BUSINESS_TYPE.RESTAURANT"
            :entity-id="+entity.id"
        >
            <template v-slot:tabs>
                <RestaurantsTabLinks />
            </template>
        </TowerSettings>
    </div>

</template>

<script>
    import RestaurantsTabLinks from '@/components/RestaurantsTabLinks';
    import TowerSettings from '@/components/tower-settings/TowerSettings';
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {

        name: 'RestaurantTowerSettings',

        components: {
            TowerSettings,
            RestaurantsTabLinks
        },
  
        data () {
            return {
                BUSINESS_TYPE,
                entity: {}
            }
        },
    
        computed: {},

        async mounted() {
            const id = this.$route.params.id;
            this.entity = (await this.axios.get(`/restaurants/${id}`)).data;
        },

        methods: {}
    }
</script>
